import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FileCopyIcon from "@mui/icons-material/FileCopy";

import {
  AppBar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Tooltip,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";
import {
  DateFromEditorComponent,
  DateToEditorComponent,
} from "../../discount-master/DatepickerEditorComponent";
import jwtDecode from "jwt-decode";
import dayjs from "dayjs";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../../utilities/ListPageHeader";
import { confirmAlert } from "react-confirm-alert";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { toast } from "react-toastify";
import { grey } from "@mui/material/colors";
import AsyncSelect from "react-select/async";
import { LinearProgress } from "@material-ui/core";
import moment from "moment";
import CustomDatePicker from "../../utilities/CustomDatePicker";

const url = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.displayMasters}`;
const uploadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileUpload}`;

const uploadFileForDisplayMaster = `${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.uploadFileForDisplayMaster}`;

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));

const UploadButton = styled(Button)(({ theme }) => ({
  fontSize: 11,
  color: "#fff !important",
  background: `${theme.palette.primary.main}`,
  borderRadius: 20,
  padding: "5px 10px",
  cursor: "pointer",
}));

const currentDate = new Date();

export default function DocUpload(props) {
  const { open, handleClose } = props;
  const [folderName, setFolderName] = useState();
  const [folderDescription, setFolderDescription] = useState();
  const [fileType, setFileType] = useState();
  const [fileName, setFileName] = useState();
  const [filePath, setFilePath] = useState();
  const [fileDescription, setFileDescription] = useState();
  const [count, setCount] = useState(0);
  const [travelDocumentList, setTravelDocumentList] = useState([
    {
      fileNo: 1,
      description: null,
      fileType: null,
      filePath: null,
      fileName: null,
      file: null,
      error: null,
    },
  ]);
  const [file, setFile] = useState();
  const [rowData, setRowData] = useState([
    {
      fileNo: "1",
      description: "Receipt",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
    {
      fileNo: "2",
      description: "Receipts",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
  ]);
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const gridRef = useRef();
  const [addedRows, setAddedRows] = useState([]);
  const [productId, setProductId] = useState([]);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [totalClaimed, setTotalClaimed] = useState();
  const [openDoc, setOpenDoc] = useState(false);
  const [docData, setData] = useState([]);
  const [docUpdate, setDocUpdate] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState(null);
  const [initialState, setInitialState] = useState({
    docNo: null,
    docDate: currentDate,
    creationDate: new Date().toISOString(),
    employeeId: null,
    employeeName: null,
    companyCode: 1,
    companyName: "Nolte FZE",
    remark: null,
    folder: [],
  });

  const docTypes = [
    {
      value: "02",
      label: "PDF",
    },
    {
      value: "03",
      label: "JPEG",
    },
    // {
    //   value: "04",
    //   label: "WINNER",
    // },
    {
      value: "05",
      label: "EXCEL",
    },
    {
      value: "06",
      label: "WORD PAD",
    },
    {
      value: "07",
      label: "POWERPOINT",
    },
    {
      value: "08",
      label: "WINRAR",
    },
  ];
  const handleAddFile = () => {
    setTravelDocumentList([
      ...travelDocumentList,
      {
        fileNo: travelDocumentList.length + 1,
        description: null,
        fileType: null,
        filePath: null,
        fileName: null,
        file: null,
        error: null,
      },
    ]);
  };
  const useStyles = makeStyles((theme) => ({
    root: {
      "& li": {
        padding: "5px 10px",
        cursor: "pointer",

        "&:hover": {
          backgroundColor: grey[800],
        },
      },
    },
  }));

  const CellSuggestionsEditor = forwardRef((props, ref) => {
    const classes = useStyles(props);
    const { colDef, value } = props;
    const [values, setValues] = useState(
      props.api
        .getRenderedNodes()
        .map((node) => node.data[colDef.field])
        .filter((v) => v.replaceAll(" ", "").length > 0)
    );
    const [filteredValues, setFilteredValues] = useState([]);
    const inputRef = useRef(null);
    const [currentValue, setCurrentValue] = useState(value);
    useEffect(() => {
      inputRef.current.focus();
      setFilteredValues(values);
    }, []);
    const _handleChange = (e) => {
      const { value } = e.target;
      setCurrentValue(value);
      setFilteredValues(values.filter((val) => val.includes(value)));
    };
    useImperativeHandle(ref, () => {
      return {
        getValue: () => currentValue,
      };
    });
    return (
      <div ref={ref} className={clsx(classes.root)}>
        <TextField
          ref={inputRef}
          value={currentValue}
          onChange={_handleChange}
          fullWidth
        />
        {currentValue !== "" && currentValue !== null && (
          <Box component={"ul"} className="suggestions">
            {filteredValues.map((fv) => (
              <li
                className="suggestion-value"
                onClick={() => setCurrentValue(fv)}
              >
                {fv}
              </li>
            ))}
          </Box>
        )}
      </div>
    );
  });

  const SelectExpenseType = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refExpenseConfig = useRef();
    const [error, setError] = useState("");
    const [expenseConfig, setExpenseConfig] = useState([]);
    const [selectedConfig, setSelectedConfig] = useState(null);
    let code = data.location.substring(0, 2);
    const claimConfig = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimConfig}/search/findByCountryCode?code=${code}`;

    const getConfigData = async () => {
      const configResult = await OAuthService.getList(claimConfig);

      const configData = configResult?.data?._embedded?.expenseClaimConfigs;

      setExpenseConfig(
        configData?.map((item) => ({
          label: item.subLedgerCode,
          value: item.subLedgerCode,
          subLedgerName: item.subLedgerName,
          maxAmount: item.maxAmount,
        }))
      );
    };

    const handleCountryChange = async (value) => {
      if (!value) return;
      data.subLedgerName = value.subLedgerName;
      data.maxAmount = value.maxAmount;
      props.node.setData(data);
      setSelectedConfig(value);
      // setOpenCom(false);
    };

    useEffect(() => {
      getConfigData();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedConfig?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refExpenseConfig}
          value={selectedConfig}
          onChange={handleCountryChange}
          options={expenseConfig}
          styles={customStyles()}
        />
      </div>
    );
  });

  const SelectLocation = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refLocation = useRef();
    const [error, setError] = useState("");
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    let countryListUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}`;

    const getCountryList = async () => {
      const dataList = await OAuthService.getList(
        countryListUrl + `?sort=name,asc&size=1000`
      );

      setCountries(
        dataList?.data?._embedded?.countries?.map((item) => ({
          label: `${item.isoCode} - ${item.name}`,
          value: item.isoCode,
        }))
      );
    };

    const handleCountryChange = async (value) => {
      if (!value) return;
      props.node.setData(data);
      setSelectedCountry(value);
      // setOpenCom(false);
    };

    useEffect(() => {
      getCountryList();
    }, []);

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedCountry?.label;
        },
      };
    });

    return (
      <div className="w-full" style={{ width: 200 }}>
        <Select
          className="basic-multi-select mb-4"
          name="name"
          required
          ref={refLocation}
          value={selectedCountry}
          onChange={handleCountryChange}
          options={countries}
          styles={customStyles()}
        />
      </div>
    );
  });

  const handleDateFormat = (props) => {
    const { data, colDef } = props;
    const date1 = new Date(data.fromDate);
    const date2 = new Date(data.toDate);
    const difference = date2.getTime() - date1.getTime();
    const daysDifference = difference / (1000 * 3600 * 24);
    let totalDays = Math.abs(daysDifference);

    data.days = totalDays.toString() === "NaN" ? 0 : totalDays;
    return props.value && moment(props.value).format("DD-MM-YYYY");
  };

  const handleFolderNo = (params) => {
    return rowData[params?.rowIndex - 1]?.fileNo;
  };
  const handleFileType = (params) => {
    return rowData[params?.rowIndex - 1]?.fileType;
  };
  const handleFilePath = (params) => {
    return rowData[params?.rowIndex - 1]?.filePath;
  };
  const handleFileDescription = (params) => {
    return rowData[params?.rowIndex - 1]?.description;
  };

  const handleFolderName = (params) => {
    return `${rowData[params?.rowIndex]?.folderName} (${
      rowData[params?.rowIndex]?.folderDescription
    })`;
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "folderName",
      headerName: "Document",
      rowGroup: true,
      hide: true,
      minWidth: 250,
      cellRenderer: handleFolderName,
    },
    {
      field: "fileNo",
      headerName: "File No",
      cellRenderer: handleFolderNo,
    },
    {
      field: "description",
      headerName: "Description",
      cellRenderer: handleFileDescription,
    },
    {
      field: "fileType",
      headerName: "File Type",
      minWidth: 150,
      cellRenderer: handleFileType,
    },
    {
      field: "filePath",
      headerName: "File Path",
      minWidth: 200,
      cellRenderer: handleFilePath,
    },
  ]);

  const token = jwtDecode(localStorage.getItem("token"));

  console.log(token.scope);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const loadData = async () => {
    let email = token.email;
    const userDataUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
    const result = await OAuthService.getList(userDataUrl);
    const user = result?.data;
    const empId = user?._links.user.href.split("/").pop();

    setInitialState({
      ...initialState,
      employeeName: user?.userName,
      employeeId: empId,
      companyName: user?.companyName,
      companyCode: user?.companyId,
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    setDocUpdate(urlParams.get("id") === null ? false : true);
    if (urlParams.get("id") !== null) {
      const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
        oAuthServiceConfig.expenseClaimList
      }/${urlParams.get("id")}`;

      const dataVal = await OAuthService.getList(dataUrl);
      let amount = dataVal?.data?.recordList?.map((item) => {
        return item.amount;
      });
      setTotalClaimed(amount);
      setInitialState(dataVal.data);
      // setRowData(dataVal.data.recordList);
    }
  };

  const onGridReady = useCallback((params) => {
    loadData();
  }, []);

  const onBtEdit = useCallback(
    (event) => {
      const RowIndex = event.node.rowIndex;
      const val = rowData[RowIndex];
    },
    [rowData]
  );

  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = [event.node.data];

      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to delete.",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              rowData?.splice(event.node.rowIndex, 1);
              gridRef?.current?.api.applyTransaction({ remove: selectedRow });
              selectedRow.map(async (row) => {
                const id = row?._links?.self?.href.split("/").pop();
                await OAuthService.deleteData(url, id);
                setSuccessMsg("Data deleted Successfully");
                setSnackState(true);
              });
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [gridRef, rowData]
  );

  const getContextMenuItems = useCallback((event) => {
    const result = [
      {
        name: "Edit",
        icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
        action: () => {
          onBtEdit(event);
        },
      },
      {
        name: "Delete",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          onBtDeleteRow(event);
        },
      },
      "separator",
      "export",
      "chartRange",
    ];
    return result;
  }, []);

  const onRowValueChanged = async (event) => {
    const { rowIndex, data } = event.node;
    const tempAddedRows = [...addedRows];
    tempAddedRows[rowIndex] = data;
    setAddedRows(tempAddedRows);
  };

  const handleEditClaim = async (props) => {
    console.log(rowData, initialState, props);

    let body =
      addedRows.length === 0
        ? {
            ...initialState,
            //   recordList: addedRows,
            docDate:
              initialState.docDate === null
                ? moment(currentDate).format("YYYY-MM-DD")
                : moment(initialState.docDate).format("YYYY-MM-DD"),
          }
        : {
            ...initialState,
            recordList: addedRows,
            docDate:
              initialState.docDate === null
                ? moment(currentDate).format("YYYY-MM-DD")
                : moment(initialState.docDate).format("YYYY-MM-DD"),
          };

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    setDocUpdate(urlParams.get("id") === null ? false : true);

    const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
      oAuthServiceConfig.expenseClaimList
    }/${urlParams.get("id")}`;

    // const addUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;
    OAuthService.updateData(dataUrl, false, body)
      .then((resp) => {
        setSuccessMsg("Data Updated Successfully");
        // setSnackState(true);
      })
      .catch((error) => setError(error.message));

    // rowsToUpdate.map((row) => {
    //   OAuthService.updateData(url, row.srNo, row)
    //     .then((resp) => {
    //       setSuccessMsg("Data Updated Successfully");
    //       setSnackState(true);
    //     })
    //     .catch((error) => setError(error.message));
    // });
  };

  const handleAddDoc = async (props) => {
    setOpenDoc(!openDoc);
  };

  const handleDocTypeChange = async (props) => {
    setSelectedDocType(props);
    setFileType(props.label);
  };

  const handleDocumentChange = async (e, item, index) => {
    const file = e.target.files[0];
    const formData = new FormData();
    await formData.append("file", file);

    OAuthService.uploadFile(uploadUrl, formData)
      .then((resp) => {
        if (resp.data.error === undefined) {
          if (item.fileNo === index + 1) {
            travelDocumentList[index].filePath = resp?.data?.downloadUri;
            travelDocumentList[index].fileName = file?.name;
            travelDocumentList[index].file = file;
            travelDocumentList[index].error = null;
            setTravelDocumentList(travelDocumentList);
          }

          setCount(count + 1);
        } else {
          if (item.fileNo === index + 1) {
            travelDocumentList[index].error = resp?.data?.error;
            setTravelDocumentList(travelDocumentList);
            setCount(count + 1);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const removeDocument = () => {
    setFileName("");
    setFile([]);
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "ExpenseClaim.xlsx",
      sheetName: "Expense Claim",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const handleSave = () => {
    // console.log(rowData);
    const folderObj = {
      folderName: folderName,
      folderDescription: folderDescription,
      travelDocumentList: travelDocumentList,
    };

    const body = {
      docNo: initialState?.docNo,
      docDate: initialState?.docDate,
      creationDate: initialState?.creationDate,
      employeeId: initialState?.employeeId,
      employeeName: initialState?.employeeName,
      companyCode: initialState?.companyCode,
      companyName: initialState.companyName,
      remark: initialState.remark,
      folder: [folderObj],
    };

    console.log(body);
  };

  return (
    <>
      <ListPageHeader
        componentName="Document"
        pageName=" Expense Claim"
        showPaginationDropdown={showPaginationDropdown}
        error={error}
        successMsg={successMsg}
        onBtExport={onBtExport}
        handleAddButton={handleAddDoc}
      />

      <div className="p-4 sm:px-24">
        <Grid container spacing={2} className="pb-6">
          <Grid xs={16} item>
            <Stack direction="row" spacing={2}>
              <Stack>
                <label>Doc Number</label>
                <TextField
                  className="mb-4 w-[120px]"
                  type="text"
                  required
                  variant="outlined"
                  fullWidth
                  value={initialState.docNo}
                  disabled
                />
              </Stack>
              <Stack>
                <span>Doc Date</span>
                <CustomDatePicker
                  className="mb-4 w-[160px]"
                  format={"dd-MM-yyyy"}
                  name={"fromDate"}
                  value={
                    initialState.docDate === null
                      ? moment(currentDate, "DD/MM/YYYY").format(
                          "ddd MMM DD YYYY 00:00:00 [GMT]ZZ [(]z[)]"
                        )
                      : initialState.docDate
                  }
                  handleChange={(date) => {
                    setInitialState({
                      ...initialState,
                      docDate: date,
                    });
                  }}
                />
              </Stack>
              <Stack>
                <label>Creation Date</label>
                <CustomDatePicker
                  className="mb-4 w-[150px]"
                  name={"creationDate"}
                  format={"dd-MM-yyyy"}
                  fullWidth
                  value={initialState.creationDate}
                  //   value={employeeId}
                  //   disabled
                />
              </Stack>
              <Stack>
                <label>EMP ID / Name</label>
                <Stack direction="row" spacing={1}>
                  <TextField
                    className="mb-4 w-[75px] "
                    type="text"
                    variant="outlined"
                    fullWidth
                    value={initialState?.employeeId}
                    disabled
                  />
                  <TextField
                    className="mb-4 "
                    type="text"
                    variant="outlined"
                    fullWidth
                    value={initialState?.employeeName}
                    disabled
                  />
                </Stack>
              </Stack>

              <Stack>
                <span>Remarks</span>
                <TextField
                  className="mb-4"
                  type="text"
                  required
                  variant="outlined"
                  value={initialState.remark}
                  onChange={(val) => {
                    setInitialState({
                      ...initialState,
                      remark: val.target.value,
                    });
                  }}
                  fullWidth
                />
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </div>

      <div className="h-full">
        <AgGridTable
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          getContextMenuItems={getContextMenuItems}
          //   rowSelection={"multiple"}
          onCellValueChanged={onRowValueChanged}
          // onRowDoubleClicked={}
          //editType={"fullRow"}
        />
      </div>

      <>
        <Dialog open={openDoc} fullWidth maxWidth="sm" component="form">
          <AppBar position="static">
            <Toolbar className="flex w-full justify-between">
              <Typography variant="subtitle1" color="inherit">
                Document Upload
              </Typography>
              <IconButton onClick={handleAddDoc}>
                <Icon>close</Icon>
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
            {/* {alreadyExistsError && (
            <Alert variant="filled" severity="error" sx={{ mb: 2 }}>
              This record already exists.
            </Alert>
          )} */}
            <Grid container>
              <Grid xs={12} item>
                <Grid container spacing={2} className="pb-16">
                  <Grid xs={6} item>
                    <div>
                      <label>Doc No</label>
                    </div>
                    <Stack>
                      <StyledTextField
                        type="text"
                        name="doc-no"
                        variant="outlined"
                        fullWidth
                        value={urlParams.get("id")}
                        disabled
                      />
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container spacing={2} className="pb-16">
                  <Grid xs={6} item>
                    <div>
                      <label>Folder Name</label>
                    </div>
                    <Stack>
                      <StyledTextField
                        type="text"
                        name="doc-no"
                        variant="outlined"
                        fullWidth
                        value={folderName}
                        onChange={(e) => {
                          setFolderName(e.target.value);
                        }}
                      />
                    </Stack>
                  </Grid>
                  <Grid xs={6} item>
                    <div>
                      <label>Folder Description</label>
                    </div>
                    <Stack>
                      <StyledTextField
                        type="text"
                        name="doc-no"
                        variant="outlined"
                        fullWidth
                        value={folderDescription}
                        onChange={(e) => {
                          setFolderDescription(e.target.value);
                        }}
                      />
                    </Stack>
                  </Grid>
                </Grid>

                {travelDocumentList.map((item, index) => {
                  return (
                    <React.Fragment>
                      <Grid
                        container
                        spacing={2}
                        className="pb-16"
                        direction={"row"}
                      >
                        <Grid xs={6} item>
                          <div>
                            <label>Doc Typename</label>
                          </div>
                          <Stack>
                            <Select
                              className="basic-multi-select mb-4"
                              name="name"
                              required
                              // value={
                              //   item.fileType ||
                              //   travelDocumentList[index].fileType
                              // }
                              onChange={(val) => {
                                if (item.fileNo === index + 1) {
                                  travelDocumentList[index].fileType = val;
                                  setCount(count + 1);

                                  setTravelDocumentList(travelDocumentList);
                                }
                              }}
                              options={docTypes}
                              styles={customStyles()}
                            />
                          </Stack>
                        </Grid>
                        <Grid xs={6} item>
                          <div>
                            <label>File Description</label>
                          </div>
                          <Stack>
                            <StyledTextField
                              type="text"
                              name="doc-date"
                              variant="outlined"
                              fullWidth
                              value={item.fileDescription}
                              onChange={(val) => {
                                if (item.fileNo === index + 1) {
                                  travelDocumentList[index].description =
                                    val.target.value;
                                  setTravelDocumentList(travelDocumentList);
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        spacing={2}
                        className="pb-16"
                        direction={"row"}
                        alignItems={"center"}
                      >
                        <Grid xs={8} item>
                          {item.fileName === null ||
                          item.fileName.length === 0 ? (
                            <Stack className="w-full mb-16">
                              <Box
                                className="flex justify-center items-center"
                                sx={{
                                  height: 180,
                                  border: "1px dotted grey",
                                }}
                              >
                                <CloudUploadIcon fontSize={"large"} />
                                <Typography className="ml-12">
                                  Upload your image
                                </Typography>
                                <Button
                                  variant="contained"
                                  component="label"
                                  color="warning"
                                  className="ml-12"
                                >
                                  <input
                                    hidden
                                    type="file"
                                    accept={
                                      travelDocumentList[index].fileType
                                        ?.value === "02"
                                        ? ".pdf"
                                        : travelDocumentList[index].fileType
                                            ?.value === "03"
                                        ? ".jpeg"
                                        : travelDocumentList[index].fileType
                                            ?.value === "05"
                                        ? ".xlsx"
                                        : travelDocumentList[index].fileType
                                            ?.value === "06"
                                        ? ".rtf,.docx"
                                        : travelDocumentList[index].fileType
                                            ?.value === "07"
                                        ? ".ppt,.pptx"
                                        : travelDocumentList[index].fileType
                                            ?.value === "08"
                                        ? ".rar,.zip"
                                        : ".pdf"
                                    }
                                    onChange={(e) =>
                                      handleDocumentChange(e, item, index)
                                    }
                                  />
                                  <Typography color="black">Browse</Typography>
                                </Button>
                              </Box>
                              <Typography color="red">{item.error}</Typography>
                            </Stack>
                          ) : (
                            <Stack className="w-full mb-16">
                              <Box className="flex justify-between">
                                <Grid className="flex">
                                  <div>
                                    <FileCopyIcon
                                      fontSize={"large"}
                                      color="warning"
                                      className=" mt-20"
                                    />
                                  </div>
                                  <div>
                                    <Typography
                                      fontSize={"large"}
                                      className="ml-12 mt-20"
                                    >
                                      {item.fileName}
                                    </Typography>
                                  </div>
                                </Grid>
                                <Grid>
                                  <FuseSvgIcon
                                    className="mt-20 w-32 h-32 cursor-pointer"
                                    onClick={() => removeDocument()}
                                  >
                                    heroicons-outline:x
                                  </FuseSvgIcon>
                                </Grid>
                              </Box>
                            </Stack>
                          )}
                        </Grid>
                        {index === travelDocumentList.length - 1 && (
                          <Grid xs={4} item>
                            <Tooltip title={"Add File"}>
                              <Button
                                variant="contained"
                                color="warning"
                                onClick={handleAddFile}
                              >
                                <FuseSvgIcon>
                                  heroicons-solid:plus-circle
                                </FuseSvgIcon>{" "}
                                File
                              </Button>
                            </Tooltip>
                          </Grid>
                        )}
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            sx={{ background: "#373c42" }}
            className="justify-between px-16 sm:px-16"
          >
            <Box>&nbsp;</Box>
            <Button
              variant="contained"
              color="primary"
              type="button"
              onClick={handleSave}
              // disabled={alreadyExistsError || btnDisabled}
            >
              {"Save & Exit"}
            </Button>
          </DialogActions>
        </Dialog>
      </>

      {/* <Button variant="contained" color="warning" size="large" onClick={handleSave}>
            Save
          </Button> */}
    </>
  );
}
